import React, { useState } from 'react';
import styles from './Setting.module.css'; 

const GetSupport = () => {
  const [formData, setFormData] = useState({
    subject: '',
    email: '',
    issue: '',
  });

  const [isSubmitted, setIsSubmitted] = useState(false); // To show confirmation after submission

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Backend integration placeholder
    console.log('Support request submitted:', formData);

    setIsSubmitted(true); // Show confirmation message
    setFormData({ subject: '', email: '', issue: '' }); // Reset form
  };

  return (
    <div className={styles.sectionContent}>
      <h2 className={styles.sectionHeader}>Get Support</h2>
      {isSubmitted ? (
        <div className={styles.successMessage}>
          <p>Thank you! Your support request has been submitted successfully.</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className={styles.formGroup}>
          {/* Subject Field */}
          <div className={styles.formGroup}>
            <label>Subject:</label>
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
              className={styles.inputField}
            />
          </div>

          {/* Email Field */}
          <div className={styles.formGroup}>
            <label>Email:</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className={styles.inputField}
            />
          </div>

          {/* Issue Field */}
          <div className={styles.formGroup}>
            <label>Issue:</label>
            <textarea
              name="issue"
              value={formData.issue}
              onChange={handleChange}
              required
              className={styles.textareaField}
            ></textarea>
          </div>

          {/* Submit Button */}
          <div className={styles.buttonGroup}>
            <button type="submit" className={styles.saveButton}>
              Submit
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default GetSupport;
